import { DEPORTIVA } from "../actions/types";

const initialState = {
    listado_asesorias: [],
    listado_asesores: [],
    detalles_asesoria: null, 
    listado_citas: [],
    detalles_cita: null,
    detalles_nota: null,
    listado_asesorias_cita: [],
    listado_horarios_cita: [], 
    ventana_filtros: false, 
    filtros: null
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case DEPORTIVA.BUSCAR_ASESORADOS:
            return {
                ...state,
                listado_asesorias: payload
            };

        case DEPORTIVA.BUSCAR_ASESORES:
            return {
                ...state,
                listado_asesores: payload
            };

        case DEPORTIVA.DETALLES_ASESORIA:

            let detalles_actuales = state.detalles_asesoria;

            if(detalles_actuales){
                detalles_actuales = {
                    ...detalles_actuales, 
                    ...payload
                }
            }else{
                detalles_actuales = payload;
            }

            return {
                ...state,
                detalles_asesoria: detalles_actuales
            };

        case DEPORTIVA.MENSAJES_ASESORIA:
            return {
                ...state, 
                detalles_asesoria: {
                    ...state.detalles_asesoria, 
                    mensajes: payload
                }
            };

        case DEPORTIVA.CREAR_MENSAJE:
            let mensajes_agregar = state.detalles_asesoria.mensajes;

            mensajes_agregar = [
                ...mensajes_agregar, payload
            ];

            return {
                ...state, 
                detalles_asesoria: {
                    ...state.detalles_asesoria, 
                    mensajes: mensajes_agregar
                }
            };

        case DEPORTIVA.AGREGAR_NOTA:
            let notas_agregar = state.detalles_asesoria.notas;

            notas_agregar = [
                payload, ...notas_agregar
            ];

            return {
                ...state, 
                detalles_asesoria: {
                    ...state.detalles_asesoria, 
                    notas: notas_agregar
                }
            };

        case DEPORTIVA.DETALLES_NOTA:
            return {
                ...state,
                detalles_nota: payload
            };

        case DEPORTIVA.EDITAR_NOTA:
            let notas_editar = state.detalles_asesoria.notas;

            notas_editar = notas_editar.map(nota => nota._id === payload._id ? payload : nota);

            return {
                ...state, 
                detalles_asesoria: {
                    ...state.detalles_asesoria, 
                    notas: notas_editar
                }
            };

        case DEPORTIVA.ELIMINAR_NOTA:
            let nota_eliminar = state.detalles_asesoria.notas;

            nota_eliminar = nota_eliminar.filter(nota => nota._id !== payload)

            return {
                ...state, 
                detalles_asesoria: {
                    ...state.detalles_asesoria, 
                    notas: nota_eliminar
                }
            };

        case DEPORTIVA.BUSCAR_CITAS:
            return {
                ...state,
                listado_citas: payload
            };

        case DEPORTIVA.BUSCAR_ASESORADOS_CITA:
            return {
                ...state,
                listado_asesorias_cita: payload
            };

        case DEPORTIVA.BUSCAR_HORARIOS_CITA:
            return {
                ...state,
                listado_horarios_cita: payload
            };

        case DEPORTIVA.AGREGAR_CITA:
            let citas_agregar = state.listado_citas;

            citas_agregar = [
                payload, ...citas_agregar
            ];

            return {
                ...state, 
                listado_citas: citas_agregar
            };

        case DEPORTIVA.DETALLES_CITA:
            return {
                ...state,
                detalles_cita: payload
            };

        case DEPORTIVA.EDITAR_CITA:
            let citas_editar = state.listado_citas;

            citas_editar = citas_editar.map(cita => cita._id === payload._id ? payload : cita);

            return {
                ...state, 
                listado_citas: citas_editar
            };

        case DEPORTIVA.ELIMINAR_CITA:
            let citas_eliminar = state.listado_citas;

            for (var i = 0; i < payload.length; i++) {
                citas_eliminar = citas_eliminar.filter(cita => cita._id !== payload[i])
            }

            return {
                ...state, 
                listado_citas: citas_eliminar
            };

        case DEPORTIVA.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };
    
        default:
            return state;
    }
}